"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("./utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var VolumeControls = /*#__PURE__*/function (_Component) {
  function VolumeControls() {
    var _this;
    _classCallCheck(this, VolumeControls);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, VolumeControls, [].concat(args));
    _this.hasAddedAudioEventListener = false;
    _this.volumeBar = function () {
      return /*#__PURE__*/(0, _react.createRef)();
    }();
    _this.volumeAnimationTimer = 0;
    _this.lastVolume = _this.props.volume;
    _this.state = function () {
      return {
        currentVolumePos: "".concat((_this.lastVolume / 1 * 100 || 0).toFixed(2), "%"),
        hasVolumeAnimation: false,
        isDraggingVolume: false
      };
    }();
    _this.getCurrentVolume = function (event) {
      var audio = _this.props.audio;
      if (!_this.volumeBar.current) {
        return {
          currentVolume: audio.volume,
          currentVolumePos: _this.state.currentVolumePos
        };
      }
      var volumeBarRect = _this.volumeBar.current.getBoundingClientRect();
      var maxRelativePos = volumeBarRect.width;
      var relativePos = (0, _utils.getPosX)(event) - volumeBarRect.left;
      var currentVolume;
      var currentVolumePos;
      if (relativePos < 0) {
        currentVolume = 0;
        currentVolumePos = '0%';
      } else if (relativePos > volumeBarRect.width) {
        currentVolume = 1;
        currentVolumePos = '100%';
      } else {
        currentVolume = relativePos / maxRelativePos;
        currentVolumePos = "".concat(relativePos / maxRelativePos * 100, "%");
      }
      return {
        currentVolume: currentVolume,
        currentVolumePos: currentVolumePos
      };
    };
    _this.handleContextMenu = function (event) {
      event.preventDefault();
    };
    _this.handleClickVolumeButton = function () {
      var audio = _this.props.audio;
      if (audio.volume > 0) {
        _this.lastVolume = audio.volume;
        audio.volume = 0;
      } else {
        audio.volume = _this.lastVolume;
      }
    };
    _this.handleVolumnControlMouseOrTouchDown = function (event) {
      event.stopPropagation();
      var audio = _this.props.audio;
      var _this$getCurrentVolum = _this.getCurrentVolume(event.nativeEvent),
        currentVolume = _this$getCurrentVolum.currentVolume,
        currentVolumePos = _this$getCurrentVolum.currentVolumePos;
      audio.volume = currentVolume;
      _this.setState({
        isDraggingVolume: true,
        currentVolumePos: currentVolumePos
      });
      if (event.nativeEvent instanceof MouseEvent) {
        window.addEventListener('mousemove', _this.handleWindowMouseOrTouchMove);
        window.addEventListener('mouseup', _this.handleWindowMouseOrTouchUp);
      } else {
        window.addEventListener('touchmove', _this.handleWindowMouseOrTouchMove);
        window.addEventListener('touchend', _this.handleWindowMouseOrTouchUp);
      }
    };
    _this.handleWindowMouseOrTouchMove = function (event) {
      if (event instanceof MouseEvent) {
        event.preventDefault();
      }
      event.stopPropagation();
      var audio = _this.props.audio;
      var windowSelection = window.getSelection();
      if (windowSelection && windowSelection.type === 'Range') {
        windowSelection.empty();
      }
      var isDraggingVolume = _this.state.isDraggingVolume;
      if (isDraggingVolume) {
        var _this$getCurrentVolum2 = _this.getCurrentVolume(event),
          currentVolume = _this$getCurrentVolum2.currentVolume,
          currentVolumePos = _this$getCurrentVolum2.currentVolumePos;
        audio.volume = currentVolume;
        _this.setState({
          currentVolumePos: currentVolumePos
        });
      }
    };
    _this.handleWindowMouseOrTouchUp = function (event) {
      event.stopPropagation();
      _this.setState({
        isDraggingVolume: false
      });
      if (event instanceof MouseEvent) {
        window.removeEventListener('mousemove', _this.handleWindowMouseOrTouchMove);
        window.removeEventListener('mouseup', _this.handleWindowMouseOrTouchUp);
      } else {
        window.removeEventListener('touchmove', _this.handleWindowMouseOrTouchMove);
        window.removeEventListener('touchend', _this.handleWindowMouseOrTouchUp);
      }
    };
    _this.handleAudioVolumeChange = function (e) {
      var isDraggingVolume = _this.state.isDraggingVolume;
      var volume = e.target.volume;
      if (_this.lastVolume > 0 && volume === 0 || _this.lastVolume === 0 && volume > 0) {
        _this.props.onMuteChange();
      }
      _this.lastVolume = volume;
      if (isDraggingVolume) return;
      _this.setState({
        hasVolumeAnimation: true,
        currentVolumePos: "".concat((volume / 1 * 100 || 0).toFixed(2), "%")
      });
      clearTimeout(_this.volumeAnimationTimer);
      _this.volumeAnimationTimer = setTimeout(function () {
        _this.setState({
          hasVolumeAnimation: false
        });
      }, 100);
    };
    return _this;
  }
  _inherits(VolumeControls, _Component);
  return _createClass(VolumeControls, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var audio = this.props.audio;
      if (audio && !this.hasAddedAudioEventListener) {
        this.audio = audio;
        this.hasAddedAudioEventListener = true;
        audio.addEventListener('volumechange', this.handleAudioVolumeChange);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.audio && this.hasAddedAudioEventListener) {
        this.audio.removeEventListener('volumechange', this.handleAudioVolumeChange);
      }
      clearTimeout(this.volumeAnimationTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        audio = _this$props.audio,
        showFilledVolume = _this$props.showFilledVolume,
        i18nVolumeControl = _this$props.i18nVolumeControl;
      var _this$state = this.state,
        currentVolumePos = _this$state.currentVolumePos,
        hasVolumeAnimation = _this$state.hasVolumeAnimation;
      var _ref = audio || {},
        volume = _ref.volume;
      return /*#__PURE__*/_react.default.createElement("div", {
        ref: this.volumeBar,
        onMouseDown: this.handleVolumnControlMouseOrTouchDown,
        onTouchStart: this.handleVolumnControlMouseOrTouchDown,
        onContextMenu: this.handleContextMenu,
        role: "progressbar",
        "aria-label": i18nVolumeControl,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": Number((volume * 100).toFixed(0)),
        tabIndex: 0,
        className: "rhap_volume-bar-area"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "rhap_volume-bar"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "rhap_volume-indicator",
        style: {
          left: currentVolumePos,
          transitionDuration: hasVolumeAnimation ? '.1s' : '0s'
        }
      }), showFilledVolume && /*#__PURE__*/_react.default.createElement("div", {
        className: "rhap_volume-filled",
        style: {
          width: currentVolumePos
        }
      })));
    }
  }]);
}(_react.Component);
var _default = exports.default = VolumeControls;